import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { isMobile } from "react-device-detect";

const FadeInSection = ({ children, direction = "leftToRight" }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.1 });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (inView && !hasAnimated && !isMobile) {
      controls.start("visible");
      setHasAnimated(true);
    }
  }, [controls, inView, hasAnimated, isMobile]);

  const variants = {
    leftToRight: {
      visible: { opacity: 1, x: 0 },
      hidden: { opacity: 0, x: -100 },
    },
    downToUp: {
      visible: { opacity: 1, y: 0 },
      hidden: { opacity: 0, y: 100 },
    },
  };

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial={isMobile ? "visible" : "hidden"}
      variants={variants[direction]}
      transition={{ duration: 1.2 }}
    >
      {children}
    </motion.div>
  );
};

export default FadeInSection;
